import { apiService } from '@/services/core/api.service'

/**
 * Movimientos de una herramienta: asignar, reasignar y devolver.
 *
 * Estaban declaradas dentro de la pantalla de asignación, así que cualquier otra
 * vista que las necesitara tenía que importar la pantalla completa.
 */

export interface AsignacionPayload {
  projectId?: string
  responsibleUserId: string
  warehouseId?: string
  notes?: string
  evidenceUrl1?: string
  evidenceUrl2?: string
  evidenceUrl3?: string
}

export interface DevolucionPayload {
  resultingStatus: string
  warehouseId?: string
  cycleUsageHours?: number
  notes?: string
  evidenceUrl1?: string
  evidenceUrl2?: string
  evidenceUrl3?: string
}

export const asignarHerramienta = (
  toolId: string,
  payload: AsignacionPayload,
): Promise<unknown> =>
  apiService.request(`/almacen/herramientas/${toolId}/asignar`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })

export const reasignarHerramienta = (
  toolId: string,
  payload: Partial<AsignacionPayload>,
): Promise<unknown> =>
  apiService.request(`/almacen/herramientas/${toolId}/reasignar`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })

export const devolverHerramienta = (
  toolId: string,
  payload: DevolucionPayload,
): Promise<unknown> =>
  apiService.request(`/almacen/herramientas/${toolId}/devolver`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })

/**
 * Reasigna, y si el back responde 409 porque la herramienta no tiene asignación
 * activa, la asigna. Ese respaldo ya existía en la pantalla y se conserva.
 */
export const reasignarOAsignar = async (
  toolId: string,
  payload: AsignacionPayload,
): Promise<void> => {
  try {
    await reasignarHerramienta(toolId, payload)
  } catch (err: unknown) {
    const e = err as { statusCode?: number }
    if (e.statusCode === 409) {
      await asignarHerramienta(toolId, payload)
    } else {
      throw err
    }
  }
}
